// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","gn-main":"gn-main-c90","is-open":"is-open-c97","bg-overlay":"bg-overlay-ae3","visible":"visible-ed9","gn-open":"gn-open-b67"};